import React from 'react';

const LineThrough = () => {
  return (
    <svg width="74" height="14" viewBox="0 0 74 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.19498 12.089C1.19498 12.089 38.1729 1.07241 72.0029 1.07384"
        stroke="#F1222F"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default LineThrough;
